import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { YesNoSelector, displaySnackbar } from '../../utilities';
import { Sidebar, NavItemsContainer, NavItem } from 'react-sidebar-web';
import {
    FaHome,
    FaHandHoldingHeart,
    FaWindowClose,
    FaSignOutAlt,
    FaFacebook,
    FaTwitter,
    FaGithub,
    FaLinkedin,
    FaComment,
    FaCog,
} from 'react-icons/fa';
import { BiUserX, BiPencil, BiImageAdd, BiCheckDouble, BiChat } from 'react-icons/bi';
import { FcRemoveImage } from 'react-icons/fc';
import { MdEventBusy } from 'react-icons/md';
import { CgWebsite } from 'react-icons/cg';
import '../../styles/Alumni/LoggedInAlumniProfile.css';
import { Navbar } from 'responsive-navbar-react';
import 'responsive-navbar-react/dist/index.css';
import { BASE_URL } from '../../settings';
import moment from 'moment';

export default function LoggedInAlumniProfile({ alumniData, fetchEvents }) {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [pageAtTop, setPageAtTop] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);

    const [allAlumniData, setAllAlumniData] = useState([]);
    const [uuid, setUuid] = useState();
    const [username, setUsername] = useState();
    const [email, setEmail] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [githubLink, setGithubLink] = useState();
    const [linkedInLink, setLinkedInLink] = useState();
    const [facebookLink, setFacebookLink] = useState();
    const [twitterLink, setTwitterLink] = useState();
    const [about, setAbout] = useState();
    const [avatar, setAvatar] = useState();
    const [classYear, setClassYear] = useState();
    const [positionName, setPositionName] = useState();
    const [mobile, setMobile] = useState();
    const [alumniFound, setAlumniFound] = useState(true);

    const [isMyProfile, setIsMyProfile] = useState(false);

    const [isSuspended, setIsSuspended] = useState(false);
    const openFileRef = useRef();
    const [isUpdating, setIsUpdating] = useState(false);

    const { clientWidth } = document.body;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        let path = window.location.pathname?.split('/');
        let id = path[path?.length - 1];

        if (state?.alumni) {
            setAlumniFound(true);
            setIsMyProfile(alumniData?.uuid == state?.alumni?.uuid || alumniData?.uuid == id);

            // 👇️ extract data from passed in alumni data
            setAllAlumniData(state?.alumni);
            setUuid(state?.alumni?.uuid);
            setUsername(state?.alumni?.username);
            setEmail(state?.alumni?.email);
            setFirstName(state?.alumni?.firstName);
            setLastName(state?.alumni?.lastName);
            setGithubLink(state?.alumni?.githubLink);
            setLinkedInLink(state?.alumni?.linkedInLink);
            setFacebookLink(state?.alumni?.facebookLink);
            setTwitterLink(state?.alumni?.twitterLink);
            setAbout(state?.alumni?.about);
            setAvatar(state?.alumni?.avatar);
            setClassYear(state?.alumni?.classYear);
            setPositionName(state?.alumni?.positionName);
            setMobile(state?.alumni?.mobile);

            let suspended = state?.alumni?.suspended;
            setIsSuspended(suspended);
            if (suspended) {
                displaySnackbar('Your account is under suspension.', true);
            }
        } else {
            // 👇️ fetch alumni by id
            fetch(`${BASE_URL}/alumni/read`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id }),
            })
                .then(async (response) => {
                    let data = await response.json();

                    setIsMyProfile(alumniData?.uuid == data?.uuid || alumniData?.uuid == id);

                    let fetched_alumni = data?.alumni;

                    if (fetched_alumni) {
                        setAlumniFound(true);
                    }

                    setAllAlumniData(fetched_alumni);
                    setUuid(fetched_alumni?.uuid);
                    setUsername(fetched_alumni?.username);
                    setEmail(fetched_alumni?.email);
                    setFirstName(fetched_alumni?.firstName);
                    setLastName(fetched_alumni?.lastName);
                    setGithubLink(fetched_alumni?.githubLink);
                    setLinkedInLink(fetched_alumni?.linkedInLink);
                    setFacebookLink(fetched_alumni?.facebookLink);
                    setTwitterLink(fetched_alumni?.twitterLink);
                    setAbout(fetched_alumni?.about);
                    setAvatar(fetched_alumni?.avatar);
                    setClassYear(fetched_alumni?.classYear);
                    setPositionName(fetched_alumni?.positionName);
                    setMobile(fetched_alumni?.mobile);

                    let suspended = fetched_alumni?.suspended;
                    setIsSuspended(suspended);
                    if (suspended) {
                        displaySnackbar('Your account is under suspension.', true);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                        setAlumniFound(false);
                        setIsMyProfile(false);
                    } else {
                        displaySnackbar('Could not fetch alumni.', true);
                        setAlumniFound(false);
                        setIsMyProfile(false);
                    }
                });
        }
    }, []);

    useEffect(() => {
        // 👇️ fetch events
        fetch(`${BASE_URL}/events`, {
            method: 'GET',
        })
            .then(async (response) => {
                let data = await response.json();

                if (Array.isArray(data?.all_events)) {
                    let temporary_all_subscriptions = [];
                    data?.all_events?.forEach((single_event) => {
                        let existing_subscribers = JSON.parse(single_event?.subscribersList);
                        if (existing_subscribers) {
                            existing_subscribers = [...existing_subscribers];
                            if (existing_subscribers) {
                                let temporary_subscriptions = [];
                                existing_subscribers?.forEach((item) => {
                                    if (item?.uuid === uuid) {
                                        temporary_subscriptions.push(single_event);
                                    }
                                });
                                temporary_all_subscriptions.push([...temporary_subscriptions]);
                            } else setSubscriptions([]);
                        } else setSubscriptions([]);
                    });
                    setSubscriptions(temporary_all_subscriptions?.flat());
                } else setSubscriptions([]);

                // let the_event = data?.event;
                // setFetchedEvent(the_event);
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    displaySnackbar('Could not reach the servers', true);
                } else {
                    displaySnackbar('Could not fetch event.', true);
                }
            });
    }, [uuid]);

    useEffect(() => {
        if (isMyProfile) {
            document.querySelector('._3drDv')?.classList?.add('isMyprofile');
        }
    }, [isMyProfile]);

    useEffect(() => {
        return () => {
            document.querySelector('._3drDv.isMyprofile')?.classList?.remove('isMyprofile');
        };
    }, []);

    // handler to remove an event from alumni's event subscriptions
    const removeEvent = (the_event) => {
        console.log(the_event);
        YesNoSelector(`Are you sure to want to unsubscribe event ${the_event?.name}?`, (reply) => {
            if (reply === 'yes') {
                let existing_subscribers = JSON.parse(the_event?.subscribersList);

                if (existing_subscribers) {
                    existing_subscribers = [...existing_subscribers];
                    if (existing_subscribers) {
                        let filtered_subscribers = existing_subscribers.filter(
                            (item) => item?.uuid !== uuid
                        );
                        fetch(`${BASE_URL}/events/update`, {
                            method: 'PATCH',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                ...the_event,
                                id: the_event?.uuid,
                                subscribers: Number(the_event.subscribers) - 1,
                                subscribersList: [...filtered_subscribers],
                            }),
                        })
                            .then(async (result) => {
                                let response = await result?.json();
                                if (response?.msg === null) {
                                    displaySnackbar(response?.errorMsg, true, 'Ok', () => {});
                                } else {
                                    fetchEvents();
                                    window.location.reload();
                                    displaySnackbar(response?.msg, false, 'Ok', () => {});
                                }
                            })
                            .catch((error) => {
                                if (error?.message == 'Failed to fetch') {
                                    displaySnackbar(
                                        'Could not reach the servers',
                                        true,
                                        'Ok',
                                        () => {}
                                    );
                                } else {
                                    displaySnackbar('Some error occured!', true, 'Ok', () => {});
                                    console.log('the error:', error);
                                }
                            });
                    }
                }
            }
        });
    };

    // 👇️ handler to logout Alumni
    const logoutAlumni = async () => {
        try {
            fetch(`/alumni/signout`, {
                method: 'POST',
            })
                .then(async (result) => {
                    let response = await result?.json();
                    if (response?.msg === null) {
                        displaySnackbar(response?.errorMsg, true);
                    } else {
                        console.log(response);
                        displaySnackbar(response?.msg, false);
                        navigate('/alumni');
                        setTimeout(() => {
                            window.location.reload();
                        }, 500);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true);
                    } else {
                        displaySnackbar('Some error occurred!', true);
                        console.log('the error:', error);
                    }
                });
        } catch (error) {
            console.log(error?.message, '\n', error);
        }
    };

    // 👇️ handler to upload alumni profile picture (avatar)
    const uploadAvatar = (e) => {
        if (avatar) {
            removeUploadedAvatar();
        }

        const file = e.target.files[0];

        if (file) {
            setAvatar(file?.name);

            const formData = new FormData();
            formData.append('alumni-profile-image', file);

            fetch(`${BASE_URL}/alumni/profile-pic-upload`, {
                method: 'POST',
                body: formData,
            })
                .then(async (result) => {
                    let response = await result.json();
                    if (response?.errorMsg) {
                        displaySnackbar(response?.errorMsg, true);
                        openFileRef.current.value = '';
                        setAvatar(null);
                    } else {
                        // displaySnackbar(response?.msg, false);
                        updateAlumni({ ...allAlumniData, avatar: file?.name }, file?.name);
                        setAvatar(file?.name);
                        window.location.reload();
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                    } else {
                        displaySnackbar(
                            'Some error occurred!\nMake sure the uploaded file is below 2MB and is an actual image!',
                            true,
                            'Ok',
                            () => {}
                        );
                        console.log('the error:', error);
                    }
                });
        }
    };

    // 👇️ handler to remove uploaded alumni profile pic (avatar)
    const removeUploadedAvatar = () => {
        YesNoSelector('Are you sure you want to remove your avatar?', (reply) => {
            if (reply === 'yes') {
                if (avatar) {
                    fetch(`${BASE_URL}/alumni/remove-profile-pic`, {
                        method: 'DELETE',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ image: avatar }),
                    })
                        .then(async (result) => {
                            let response = await result.json();
                            if (response?.errorMsg) {
                                displaySnackbar(response?.errorMsg, true);
                            } else {
                                openFileRef.current.value = '';
                                setAvatar(null);
                                updateAlumni({ ...allAlumniData, avatar: null }, null);
                            }
                        })
                        .catch((error) => {
                            if (error?.message == 'Failed to fetch') {
                                displaySnackbar(
                                    'Could not reach the servers',
                                    true,
                                    'Ok',
                                    () => {}
                                );
                            } else {
                                displaySnackbar('Some error occurred!', true, 'Ok', () => {});
                                console.log('the error:', error);
                            }
                        });
                }
            }
        });
    };

    // 👇️ handler to update alumni
    const updateAlumni = (data, avatar = null) => {
        fetch(`${BASE_URL}/alumni/update`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...data,
                id: uuid,
                avatar: avatar,
            }),
        })
            .then(async (result) => {
                let response = await result.json();
                if (response?.errorMsg) {
                    displaySnackbar(response?.errorMsg, true);
                } else {
                    displaySnackbar(response?.msg, false);
                }
            })
            .catch((error) => {
                if (error?.message == 'Failed to fetch') {
                    displaySnackbar('Could not reach the servers', true);
                } else {
                    console.log(error);
                    displaySnackbar('Could not update alumni.', true);
                }
            });
    };

    // navbar item styles
    const navbarItemStyles = {
        span: { display: 'flex', alignItems: 'center' },
        icon: { marginRight: '.5rem' },
    };

    // props for the nav bar
    const props = {
        items: [
            {
                text: <span onClick={() => navigate('/')}>{<CgWebsite />} Home Page</span>,
                link: '',
            },
            {
                text: <span>{<FaHome />} Home</span>,
                link: '',
            },
            {
                text: (
                    <span
                        onClick={() =>
                            navigate(`/alumni/inbox/${uuid}`, {
                                state: { alumni: allAlumniData },
                            })
                        }
                    >
                        {<FaComment />} Inbox
                    </span>
                ),
            },
            {
                text: (
                    <span
                        onClick={() => {
                            window.location.assign('https://www.hit.ac.zw/online-payments/');
                        }}
                    >
                        {<FaHandHoldingHeart />} Donate
                    </span>
                ),
                link: 'https://www.hit.ac.zw/online-payments/',
            },
            {
                text: <span onClick={logoutAlumni}>{<FaSignOutAlt />} Logout</span>,
            },
            {
                // text: <span>{<FaWindowClose />} Delete Profile</span>,
                link: '',
            },
        ],
        logo: {
            text: (
                <img
                    src={require('../../images/logo.png')}
                    style={{
                        backgroundColor: 'white',
                        padding: 8,
                        borderRadius: 10,
                        margin: 0,
                    }}
                    alt='logo'
                />
            ),
            link: '/',
        },
        style: {
            barStyles: {
                background: 'darkblue',
                paddingTop: 10,
                paddingBottom: 10,
                zIndex: 100000000,
                boxShadow: pageAtTop ? 'none' : '5px 5px 35px #000',
                transition: 'all .25 ease-out',
            },
            sidebarStyles: {
                background: '#222',
                buttonColor: 'white',
            },
        },
        // float: true,
    };

    return (
        <>
            {/* Nav Bar section  */}
            {clientWidth <= 768 && <Navbar {...props} />}

            <div
                className='alumni-profile-container loggedIn-profile'
                style={{ marginLeft: isMyProfile && clientWidth > 768 ? '3rem' : '0' }}
            >
                {isMyProfile && clientWidth > 768 && (
                    <Sidebar>
                        <NavItemsContainer>
                            <NavItem label='Home Page' to='/' icon={<CgWebsite />} />
                            <NavItem label='Home' to='#' icon={<FaHome />} />
                            <NavItem
                                label='Inbox'
                                to={`/alumni/inbox/${uuid}`}
                                onClick={() =>
                                    navigate(`/alumni/inbox/${uuid}`, {
                                        state: { alumni: allAlumniData },
                                    })
                                }
                                icon={<FaComment />}
                            />
                            {/* <NavItem label='Settings' to='#' icon={<FaCog />} /> */}
                            <NavItem
                                label='Donate'
                                to='#'
                                onClick={() => {
                                    window.location.assign(
                                        'https://www.hit.ac.zw/online-payments/'
                                    );
                                }}
                                icon={<FaHandHoldingHeart />}
                            />
                            <NavItem
                                label='Logout'
                                to='#'
                                onClick={logoutAlumni}
                                icon={<FaSignOutAlt />}
                            />
                            {/* <NavItem label='Delete Profile' to='#' icon={<FaWindowClose />} /> */}
                        </NavItemsContainer>
                    </Sidebar>
                )}

                {alumniFound ? (
                    <>
                        <div className='profile-header-container'>
                            <button className='go-back-btn' onClick={() => navigate(-1)}>
                                👈️ Go back
                            </button>

                            <div className='profile-picture-container'>
                                <img
                                    src={
                                        avatar
                                            ? `${BASE_URL}/alumni/uploads/get-profile-pic/${avatar}`
                                            : require('../../images/profile-pictures/face1.jpg')
                                    }
                                    alt='profile-picture'
                                />
                                {isMyProfile && (
                                    <>
                                        {/* {!avatar ? (
                                            <BiImageAdd
                                                size={45}
                                                color='white'
                                                className='edit-pen'
                                                onClick={() => {
                                                    openFileRef.current.value = '';
                                                    openFileRef.current?.click();
                                                }}
                                            />
                                        ) : (
                                            <BiImageAdd
                                                size={45}
                                                color='white'
                                                className='edit-pen'
                                                onClick={() => openFileRef.current?.click()}
                                            />
                                        )} */}
                                        {avatar ? (
                                            <FcRemoveImage
                                                size={45}
                                                className='remove-image'
                                                onClick={removeUploadedAvatar}
                                            />
                                        ) : (
                                            <BiImageAdd
                                                size={45}
                                                color='white'
                                                className='edit-pen'
                                                onClick={() => openFileRef.current?.click()}
                                            />
                                        )}
                                        <input
                                            type='file'
                                            name='alumni-profile-image'
                                            placeholder='Profile Pic'
                                            hidden
                                            ref={openFileRef}
                                            onChange={(e) => uploadAvatar(e)}
                                        />
                                    </>
                                )}
                            </div>
                        </div>

                        <div className='profile-content-container'>
                            {isMyProfile ? (
                                <button
                                    className='edit-profile-button'
                                    onClick={() => {
                                        setIsUpdating(!isUpdating);
                                        if (isUpdating) {
                                            updateAlumni(
                                                {
                                                    username,
                                                    email,
                                                    firstName,
                                                    lastName,
                                                    githubLink,
                                                    linkedInLink,
                                                    facebookLink,
                                                    twitterLink,
                                                    about,
                                                    avatar,
                                                    classYear,
                                                    positionName,
                                                    mobile,
                                                    id: uuid,
                                                },
                                                avatar
                                            );
                                        }
                                    }}
                                >
                                    {isUpdating ? (
                                        <>
                                            <span>Save Changes</span>
                                            <BiCheckDouble
                                                className='edit-profile-icon'
                                                size={25}
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <span>Edit Profile</span>{' '}
                                            <BiPencil className='edit-profile-icon' size={25} />
                                        </>
                                    )}
                                </button>
                            ) : (
                                <button
                                    className='edit-profile-button'
                                    onClick={() => navigate(`/alumni/chat/${uuid}`)}
                                >
                                    Chat with @{username}{' '}
                                    <span>
                                        {<BiChat size={25} className='edit-profile-icon' />}
                                    </span>
                                </button>
                            )}

                            <div className='profile-content-item about'>
                                <div className='header'>
                                    <span>About</span>
                                </div>
                                {isUpdating ? (
                                    <textarea
                                        type='text'
                                        name='about'
                                        placeholder='About you...'
                                        rows={5}
                                        value={about}
                                        onChange={(e) => setAbout(e.target.value)}
                                    />
                                ) : (
                                    <div className='text'>
                                        {about?.length > 0 ? (
                                            <span>{about}</span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className='profile-content-items'>
                                <div className='profile-content-item'>
                                    <div className='header'>
                                        {isUpdating ? (
                                            <span>First name</span>
                                        ) : (
                                            <span>Full name</span>
                                        )}
                                    </div>
                                    <div className='text'>
                                        {isUpdating ? (
                                            <>
                                                <input
                                                    type='text'
                                                    name='firstName'
                                                    placeholder='First name'
                                                    value={firstName}
                                                    onChange={(e) => setFirstName(e.target.value)}
                                                />
                                            </>
                                        ) : firstName?.length > 0 || lastName?.length > 0 ? (
                                            <span>
                                                {firstName} {lastName}
                                            </span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>

                                {isUpdating && (
                                    <div className='profile-content-item'>
                                        <div className='header'>
                                            <span>Last name</span>
                                        </div>
                                        <div className='text'>
                                            <input
                                                type='text'
                                                name='lastName'
                                                placeholder='Last name'
                                                value={lastName}
                                                onChange={(e) => setLastName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className='profile-content-item'>
                                    <div className='header'>
                                        <span>Username</span>
                                    </div>
                                    <div className='text'>
                                        {isUpdating ? (
                                            <input
                                                type='text'
                                                name='username'
                                                placeholder='Username'
                                                value={username}
                                                onChange={(e) => setUsername(e.target.value)}
                                            />
                                        ) : username?.length > 0 ? (
                                            <span>@{username}</span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>

                                <div className='profile-content-item'>
                                    <div className='header'>
                                        <span>Email</span>
                                    </div>
                                    <div className='text'>
                                        {isUpdating ? (
                                            <input
                                                type='email'
                                                name='email'
                                                placeholder='Email'
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        ) : email?.length > 0 ? (
                                            <span>{email}</span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>

                                <div className='profile-content-item'>
                                    <div className='header'>
                                        <span>Class of</span>
                                    </div>
                                    <div className='text'>
                                        {isUpdating ? (
                                            <input
                                                style={{ marginTop: '0' }}
                                                type='date'
                                                id='classYear'
                                                name='classYear'
                                                placeholder={`graduating year e.g ${new Date().getFullYear()}`}
                                                value={classYear}
                                                onChange={(e) => setClassYear(e.target.value)}
                                            />
                                        ) : classYear?.length > 0 ? (
                                            <span>{new Date(classYear).getFullYear()}</span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>

                                <div className='profile-content-item'>
                                    <div className='header'>
                                        <span>Current work position</span>
                                    </div>
                                    <div className='text'>
                                        {isUpdating ? (
                                            <input
                                                type='text'
                                                name='positionName'
                                                placeholder='Current employment position e.g Software Engineer'
                                                value={positionName}
                                                onChange={(e) => setPositionName(e.target.value)}
                                            />
                                        ) : positionName?.length > 0 ? (
                                            <span>{positionName}</span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>

                                <div className='profile-content-item'>
                                    <div className='header'>
                                        <span>Mobile contact</span>
                                    </div>
                                    <div className='text'>
                                        {isUpdating ? (
                                            <input
                                                type='tel'
                                                name='mobile'
                                                placeholder='Mobile number e.g 7x-xxx-xxxx'
                                                // pattern='[7]{1}-[0-9]{2}-[0-9]{6}'
                                                value={mobile}
                                                maxLength={9}
                                                max={9}
                                                onChange={(e) => {
                                                    let value = e.target.value;
                                                    value = value?.replace(
                                                        /^(\d{2})(\d{3})(\d{4})/g,
                                                        '$1-$2-$3'
                                                    );
                                                    setMobile(value);
                                                }}
                                            />
                                        ) : mobile?.length > 0 ? (
                                            <span>(+263) {mobile}</span>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>

                                <div className='profile-content-item'>
                                    <div className='header'>
                                        <span>Social contacts</span>
                                    </div>
                                    <div className='social-links'>
                                        {isUpdating ? (
                                            <>
                                                <div className='input-with-icon'>
                                                    <FaGithub className='input-icon' size={25} />
                                                    <input
                                                        type='url'
                                                        id='githubLink'
                                                        name='githubLink'
                                                        placeholder='Github Link'
                                                        value={githubLink}
                                                        onChange={(e) =>
                                                            setGithubLink(e.target.value)
                                                        }
                                                    />
                                                </div>
                                                <div className='input-with-icon'>
                                                    <FaLinkedin
                                                        color='darkblue'
                                                        className='input-icon'
                                                        size={25}
                                                    />
                                                    <input
                                                        type='url'
                                                        name='linkedInLink'
                                                        placeholder='LinkedIn link'
                                                        value={linkedInLink}
                                                        onChange={(e) =>
                                                            setLinkedInLink(e.target.value)
                                                        }
                                                    />
                                                </div>
                                                <div className='input-with-icon'>
                                                    <FaFacebook
                                                        color='darkblue'
                                                        className='input-icon'
                                                        size={25}
                                                    />
                                                    <input
                                                        type='url'
                                                        name='facebookLink'
                                                        placeholder='Facebook link'
                                                        value={facebookLink}
                                                        onChange={(e) =>
                                                            setFacebookLink(e.target.value)
                                                        }
                                                    />
                                                </div>

                                                <div className='input-with-icon'>
                                                    <FaTwitter
                                                        color='skyblue'
                                                        className='input-icon'
                                                        size={25}
                                                    />
                                                    <input
                                                        type='url'
                                                        name='twitterLink'
                                                        placeholder={'Twitter Link'}
                                                        value={twitterLink}
                                                        onChange={(e) =>
                                                            setTwitterLink(e.target.value)
                                                        }
                                                    />
                                                </div>
                                            </>
                                        ) : facebookLink?.length > 0 ||
                                          githubLink?.length > 0 ||
                                          twitterLink?.length > 0 ||
                                          linkedInLink?.length > 0 ? (
                                            <>
                                                {facebookLink?.length > 0 && (
                                                    <a href={facebookLink}>
                                                        <FaFacebook size={30} color='darkblue' />
                                                    </a>
                                                )}
                                                {githubLink?.length > 0 && (
                                                    <a href={githubLink}>
                                                        <FaGithub size={30} color='black' />
                                                    </a>
                                                )}
                                                {twitterLink?.length > 0 && (
                                                    <a href={twitterLink}>
                                                        <FaTwitter size={30} color='skyblue' />
                                                    </a>
                                                )}
                                                {linkedInLink?.length > 0 && (
                                                    <a href={linkedInLink}>
                                                        <FaLinkedin size={30} color='darkblue' />
                                                    </a>
                                                )}
                                            </>
                                        ) : (
                                            <span>...</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className='profile-content-item'>
                                <div className='header'>
                                    <span>Event Subscriptions</span>
                                </div>
                                {subscriptions &&
                                Array.isArray(subscriptions) &&
                                subscriptions?.length > 0 ? (
                                    <ul className='qualifications-list events'>
                                        {Array.isArray(subscriptions) &&
                                            subscriptions?.map((item, index) => (
                                                <div
                                                    className='event-subscriber-item'
                                                    key={`${item?.uuid}-#${index}`}
                                                >
                                                    <div
                                                        className='left'
                                                        onClick={() => removeEvent(item)}
                                                    >
                                                        <MdEventBusy
                                                            size={30}
                                                            className='event-remove-icon'
                                                            color={'red'}
                                                        />
                                                    </div>
                                                    <div
                                                        className='right'
                                                        onClick={() =>
                                                            navigate(
                                                                `/info/eventDetail/${item?.uuid}`
                                                            )
                                                        }
                                                    >
                                                        <li
                                                            style={{ backgroundColor: item?.color }}
                                                            className='qualifications-list-item name'
                                                        >
                                                            {item?.name}
                                                        </li>

                                                        <li className='qualifications-list-item'>
                                                            starting: (
                                                            {new Date(item?.startDate)
                                                                .toISOString()
                                                                .slice(0, 10)}
                                                            ){' '}
                                                            {moment(
                                                                new Date(item?.startDate)
                                                            ).fromNow()}
                                                        </li>
                                                        <li className='qualifications-list-item'>
                                                            ending: (
                                                            {new Date(item?.endDate)
                                                                .toISOString()
                                                                .slice(0, 10)}
                                                            ){' '}
                                                            {moment(
                                                                new Date(item?.endDate)
                                                            ).fromNow()}{' '}
                                                        </li>
                                                    </div>
                                                </div>
                                            ))}
                                    </ul>
                                ) : (
                                    <p className='empty-text'>...</p>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <div className='alumni-not-found-container'>
                        <BiUserX size={100} color='#777' className='alumni-not-found-icon' />
                        <span> alumni profile not found </span>
                    </div>
                )}
            </div>
        </>
    );
}
